import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';
import { Iteration } from 'Component/others';

export const HeadSkeleton = () => {
  return (
    <Box className={styles['head-skeleton__container']}>
      <Box className={styles['head-skeleton__breadcrumb']}>
        <SkeletonComponent height="22px" width="130px" />
        <SkeletonComponent height="22px" width="20px" />
        <SkeletonComponent height="22px" width="130px" />
      </Box>
      <Box>
        <SkeletonComponent height="34px" width="150px" />
      </Box>
      <Box className={styles['head-skeleton__period-button-wrapper']}>
        <SkeletonComponent height="34px" width="130px" />
        <SkeletonComponent height="40px" width="98px" />
      </Box>
    </Box>
  );
};

export const TableSkeleton = () => {
  return (
    <Box data-testid="table-report-attendance__skeleton">
      <Table>
        <Thead>
          <Tr>
            <Th className={styles['skeleton__head']} minWidth="150px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
                <SkeletonComponent height="22px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="154px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
                <SkeletonComponent height="22px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="163px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
                <SkeletonComponent height="22px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="220px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
                <SkeletonComponent height="22px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="170px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
                <SkeletonComponent height="22px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="220px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
                <SkeletonComponent height="22px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="170px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
                <SkeletonComponent height="22px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="100px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          <Iteration
            items={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
            render={(num) => {
              return (
                <Tr key={num}>
                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="80%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="80%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>
                </Tr>
              );
            }}
          />
        </Tbody>
      </Table>
    </Box>
  );
};
